import { HTTP_AP_ListCases_ForPipelineTable_Request_Filter, HTTP_AP_ListCases_ForPipelineTable_Request_Sort } from '@api-new/caseservice';
import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { PipelineCaseTableRowModel } from '@platform/case/models/pipeline-case-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { AdjustedNetworkFilterModel } from '@shared/models/adjusted-network-filter.model';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const pipelineCaseTableFilterDefaults: AdjustedNetworkFilterModel<HTTP_AP_ListCases_ForPipelineTable_Request_Filter> = {
  createdAt: null,
  clientUserDisplayNameOrEmail: '',
  networkIds: [],
  companyIds: [],
  advisorUserDisplayNameOrEmail: '',
  propertyValue: { min: null, max: null },
  loanAmount: { min: null, max: null },
  updatedAt: null,
  caseType: null,
  mortgageExpiryTypes: null,
};

export const pipelineCaseTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<PipelineCaseTableRowModel, HTTP_AP_ListCases_ForPipelineTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameShort,
    width: {
      min: '150px',
      max: '150px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Case type',
    columnKey: 'caseTypeMapped',
    sortKey: 'byCaseType',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'Company',
    columnKey: 'companyTradingName',
    sortKey: 'byCompanyTradingName',
    type: RowDefinitionTypeEnum.Text,
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Expiry type',
    columnKey: 'mortgageExpiryTypeMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Adviser',
    columnKey: 'advisorUserDisplayName',
    sortKey: 'byAdvisorUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameInitials,
    width: {
      min: '85px',
      max: '85px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
  },
  {
    columnLabel: 'Loan amount',
    columnKey: 'loanAmount',
    sortKey: 'byLoanAmount',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'LTV',
    columnKey: 'ltv',
    type: RowDefinitionTypeEnum.Percent,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Property value',
    columnKey: 'propertyValue',
    sortKey: 'byPropertyValue',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Address',
    columnKey: 'address',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '300px',
      max: '300px',
    },
  },
  {
    columnLabel: 'Created',
    columnKey: 'createdAt',
    sortKey: 'byCreatedAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Last updated',
    columnKey: 'updatedAt',
    sortKey: 'byUpdatedAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    width: {
      min: '100px',
      max: '100px',
    },
  },
];
